// Package Imports
import moment from 'moment';
// Project Imports
import getDateValue from './getDateValue';

function generateMonthlyList() {
  const monthlyData = [];
  for (let i = 0; i < 12; i += 1) {
    const monthName = moment().month(i).format('MMMM');
    monthlyData.push(monthName);
  }
  return monthlyData;
}

export default function getDateInterval(date) {
  const match = date.match(/([A-Za-z]+) \((\d{4})\)/);
  const currentDate = new Date();
  const year = currentDate.getFullYear();
  let formattedStartDate;
  let formattedEndDate;

  if (date?.includes('-')) {
    const [startMonth, endMonth] = date.split('-');
    const startMonthIndex = generateMonthlyList().findIndex(
      (month) => month === startMonth
    );
    const endMonthIndex = generateMonthlyList().findIndex(
      (month) => month === endMonth
    );
    formattedStartDate = getDateValue(new Date(year, startMonthIndex, 1));
    formattedEndDate = getDateValue(new Date(year, endMonthIndex + 1, 0));
  } else if (match) {
    const monthVal = match[1];
    const yearVal = match[2];
    formattedStartDate = `${yearVal}-${String(new Date(Date.parse(`${monthVal} 1, ${yearVal}`)).getMonth() + 1).padStart(2, '0')}-01`;
    const endDate = new Date(
      yearVal,
      new Date(Date.parse(`${monthVal} 1, ${yearVal}`)).getMonth() + 1,
      0
    );
    formattedEndDate = `${yearVal}-${String(endDate.getMonth() + 1).padStart(2, '0')}-${String(endDate.getDate()).padStart(2, '0')}`;

    console.log(formattedStartDate, formattedEndDate);
  } else {
    const monthIndex = generateMonthlyList().findIndex(
      (month) => month === date
    );
    formattedStartDate = getDateValue(new Date(year, monthIndex, 1));
    formattedEndDate = getDateValue(new Date(year, monthIndex + 1, 0));
  }
  return `${formattedStartDate} - ${formattedEndDate}`;
}
